import { render } from "./main-box.vue?vue&type=template&id=e21068a2&ts=true"
import script from "./main-box.vue?vue&type=script&lang=ts"
export * from "./main-box.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__